export default __webpack_public_path__ + "static/apple-1b6739aad9feb356e5590975cf8d6688.png";